const Inputmask = require('inputmask').default;

document.addEventListener('DOMContentLoaded', function () {
    const im = new Inputmask("059 999 9999");
    im.mask(document.querySelectorAll(".phone-mask"));
});